import { ConfirmDialog, notify } from "@/components/kit";
import { useDeletePromotion } from "@/hooks/api/promotion/useDeletePromotion";
import { Promotion } from "@/types";
import { getApiErrorMessage } from "@/utils/api-error";

interface DeletePromotionModalProps {
  isOpen: boolean;
  onClose: () => void;
  promotion: Promotion | null;
}

export function DeletePromotionModal({
  isOpen,
  onClose,
  promotion,
}: DeletePromotionModalProps) {
  const { mutate: deletePromotion, isPending } = useDeletePromotion();

  const handleDelete = () => {
    if (!promotion) return;

    deletePromotion(promotion.id, {
      onSuccess: () => {
        notify.success("Promotion deleted");
        onClose();
      },
      onError: (error) => {
        notify.error(
          "Failed to delete promotion",
          getApiErrorMessage(error, "Please try again"),
        );
      },
    });
  };

  return (
    <ConfirmDialog
      confirmLabel="Delete"
      isOpen={isOpen}
      isPending={isPending}
      title="Delete promotion?"
      onClose={onClose}
      onConfirm={handleDelete}
    >
      <p>
        {promotion?.name} stops applying to carts right away.
        {promotion?.code
          ? ` The code ${promotion.code} stays reserved and cannot be reused.`
          : ""}
      </p>
    </ConfirmDialog>
  );
}
